import React from 'react';
import Svg, {
  Defs, G, Path, Rect, Circle, Pattern, Use, Stop, Mask,
} from 'react-native-svg';

const NoSpacesImage = () => <Svg width='196' height='121' viewBox='0 0 196 121' fill='none'>
  <Rect x='21' width='154' height='120' rx='8' fill='#E6EEF7' />
  <Mask id='mask0_232_12832' maskUnits='userSpaceOnUse' x='21' y='0' width='148' height='120'>
    <Path d='M168.155 11.1809C170.444 5.89836 166.572 0 160.815 0H29.5C25.0817 0 21.5 3.58172 21.5 8V112C21.5 116.418 25.0817 120 29.5 120H115.748C118.936 120 121.82 118.107 123.088 115.181L168.155 11.1809Z' fill='url(#paint0_linear_232_12832)' />
  </Mask>
  <G mask='url(#mask0_232_12832)'>
    <Rect width='54.9138' height='36.9138' transform='matrix(-1 0 0 1 88.957 12.0432)' fill='#E5541F' fillOpacity='0.24' />
    <Path d='M88.957 12.0432L34.0432 12.0432' stroke='#E5541F' strokeWidth='0.507184' />
    <Path d='M88.957 48.9568L34.0432 48.9568' stroke='#E5541F' strokeWidth='0.507184' />
    <Path d='M88.957 48.957L88.957 12.0432' stroke='#E5541F' strokeWidth='0.507184' />
    <Path d='M34.0435 48.957L34.0435 12.0432' stroke='#E5541F' strokeWidth='0.507184' />
    <Circle cx='2.28233' cy='2.28233' r='2.28233' transform='matrix(-1 0 0 1 91.2393 9.76074)' fill='#E5541F' />
    <Circle cx='1.52155' cy='1.52155' r='1.52155' transform='matrix(-1 0 0 1 90.4785 10.5215)' fill='#FCEEE9' />
    <Circle cx='2.28233' cy='2.28233' r='2.28233' transform='matrix(-1 0 0 1 91.2393 46.6746)' fill='#E5541F' />
    <Circle cx='1.52155' cy='1.52155' r='1.52155' transform='matrix(-1 0 0 1 90.4785 47.4353)' fill='#FCEEE9' />
    <Circle cx='2.28233' cy='2.28233' r='2.28233' transform='matrix(-1 0 0 1 36.3257 9.76074)' fill='#E5541F' />
    <Circle cx='1.52155' cy='1.52155' r='1.52155' transform='matrix(-1 0 0 1 35.5649 10.5215)' fill='#FCEEE9' />
    <Circle cx='2.28233' cy='2.28233' r='2.28233' transform='matrix(-1 0 0 1 36.3257 46.6746)' fill='#E5541F' />
    <Circle cx='1.52155' cy='1.52155' r='1.52155' transform='matrix(-1 0 0 1 35.5649 47.4353)' fill='#FCEEE9' />
  </G>
  <G filter='url(#filter0_d_232_12832)'>
    <Rect x='7' y='64' width='182' height='48' rx='4' fill='white' />
    <Circle cx='31' cy='88' r='16' fill='#548FC8' />
    <Path fillRule='evenodd' clipRule='evenodd' d='M30.567 79.6667V87.6362L23.5 91.6949V83.6504L30.567 79.6667ZM38.5 91.6949L31.433 87.6362V79.6667L38.5 83.6504V91.6949ZM24.001 92.3882L31 88.3685L37.999 92.3882L31 96.3334L24.001 92.3882Z' fill='white' />
    <Rect x='55' y='79.5' width='36' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='55' y='92.5' width='36' height='4' rx='2' fill='#B0CBE6' />
    <Rect x='144' y='84' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='167' y='84' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='7.5' y='64.5' width='181' height='47' rx='3.5' stroke='#F4F7FB' />
  </G>
  <Defs>
    <Pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
      <Use transform='matrix(0.000957464 0 0 0.000981257 -0.371258 0)' />
    </Pattern>
    <filter id='filter0_d_232_12832' x='0' y='59' width='196' height='62' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
      <feFlood floodOpacity='0' result='BackgroundImageFix' />
      <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
      <feMorphology radius='1' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_232_12832' />
      <feOffset dy='2' />
      <feGaussianBlur stdDeviation='3' />
      <feColorMatrix type='matrix' values='0 0 0 0 0.690196 0 0 0 0 0.796078 0 0 0 0 0.901961 0 0 0 0.08 0' />
      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_232_12832' />
      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_232_12832' result='shape' />
    </filter>
    <linearGradient id='paint0_linear_232_12832' x1='19.5' y1='53.5' x2='148.5' y2='53.5' gradientUnits='userSpaceOnUse'>
      <Stop stopColor='#E6EEF7' />
      <Stop offset='1' stopColor='#E6EEF7' stopOpacity='0' />
    </linearGradient>
  </Defs>
</Svg>;

export default NoSpacesImage;
